import React from "react";
import AntdAffix from 'antd/lib/affix';

const Affix = (props) => <AntdAffix {...props} />
export default Affix;




// WEBPACK FOOTER //
// ./src/components/affix/index.tsx